module.exports = __webpack_public_path__ + "img/ico_ns_community.1e309561.svg";